/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/dashboard-setup.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import { getFieldChangeItems, getProcessedFieldChangeItems } from 'views/pages/admin/audit-log/service';

const DashboardSetupChangeGrid = ({ oldRecord, newRecord, oldItem, newItem, additionalInfo }: any) => {
    const getPanels = (record: any, additionalInfo: any) => {
        const panels = record.Panels?.filter((item: any) => item);
        return panels?.length
            ? panels.map((item: any) => {
                  item.name = additionalInfo.panels.find((el: any) => el.id === item.PanelId.$oid)?.name;
                  item.ChildPanels = item.ChildPanels.map((element: any) => {
                      const name = additionalInfo.panels.find((el: any) => el.id === element.PanelId.$oid)?.name;
                      return {
                          ...element,
                          name,
                      };
                  });
                  item.DataReviews = item.DataReviews.map((element: any) => {
                      const name = additionalInfo.dataReviewTablesForStudy.find(
                          (el: any) => el.id === element.DataReviewId.$oid,
                      )?.name;
                      return {
                          ...element,
                          name,
                      };
                  });
                  return item;
              })
            : null;
    };

    const refactoredOldRecord = {
        ...oldRecord,
        Configuration: getPanels(oldRecord, additionalInfo),
        Panels: null,
        CfId: oldRecord.CfId?.$oid,
    };

    const refactoredNewRecord = {
        ...newRecord,
        Configuration: getPanels(newRecord, additionalInfo),
        Panels: null,
        CfId: newRecord.CfId?.$oid,
    };

    const arrayOfObjects = {
        Configuration: {
            valueResolver: (recordData: any, item: any) => {
                if (recordData == null) return null;
                let value = '';
                value += `Main Panel: ${recordData.name} Order: ${recordData.Index}. `;
                recordData.ChildPanels.forEach((element: any, index: number) => {
                    value += `Companion Panel: ${element.name} Order: 
                    ${element.Index}${index === recordData.ChildPanels.length - 1 ? '.' : ','} `;
                });
                recordData.DataReviews.forEach((element: any, index: number) => {
                    value += `Data Table: ${element.name} Order: 
                    ${element.Index}${index === recordData.DataReviews.length - 1 ? '.' : ','} `;
                });
                return value;
            },
        },
    };

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({
            oldRecord: refactoredOldRecord,
            newRecord: refactoredNewRecord,
            oldItem,
            newItem,
            field,
            arrayOfObjects,
            compareArrayOfObjectsFields: ['Configuration'],
        }),
    );

    return <FieldChangeGrid items={items} />;
};

export { DashboardSetupChangeGrid };
